var map = {
	"./cards.svg": 72546,
	"./commOfferReady.svg": 84597,
	"./dafWasFilled.svg": 21375,
	"./demoSettingUp.png": 87235,
	"./docs.svg": 87286,
	"./high-risk.png": 36250,
	"./swytch.png": 53933,
	"./uploadDocs.svg": 11578,
	"./waiting.svg": 93912,
	"./wallet.svg": 82091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34407;